import { render } from "./VerifySlide.vue?vue&type=template&id=621e58fd"
import script from "./VerifySlide.vue?vue&type=script&lang=js"
export * from "./VerifySlide.vue?vue&type=script&lang=js"

import exportComponent from "/Users/h5/Desktop/project/外包/shugutong/yxLink/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__